/**
 * @typedef {import('../../../../App/shared/AgentService/Agent').AgentSettings} AgentSettings
 * @typedef {{data: AgentSettings; error: string|null;isGettingData: boolean}} Response
 */

import { agentService } from '../../../../service-container';
import { translate } from '../../../../App/Internationalization';
import { useEffect, useMemo, useState } from 'react';
import captureError from '../../../../utils/captureError';

/**
 * @param {boolean} isGated
 * @returns {Response}
 */
export default function useGetAgentSettings(isGated = false) {
	const [error, setError] = useState(/** @type {string|null} */ (null));
	const [isGettingData, setIsGettingData] = useState(true);
	const [settings, setSettings] = useState(/** @type {AgentSettings} */ ({}));

	useEffect(() => {
		if (isGated) {
			setIsGettingData(false);
			return;
		}

		fetchData();
	}, [isGated]);

	async function fetchData() {
		setIsGettingData(true);

		try {
			const response = await agentService.getAgentSettings();
			setSettings(response);
		} catch (exception) {
			captureError(exception);
			setError(translate('settings.error.fetch'));
		} finally {
			setIsGettingData(false);
		}
	}

	return useMemo(
		() => ({
			data: settings,
			error,
			isGettingData,
		}),
		[error, isGettingData, settings]
	);
}
